import type { Chart } from "../Chart";
import { Theme, Fonts } from "../theme";
import { formatPrice, formatCrosshairTime } from "../util";
import { drawAxisTag } from "./PriceAxis";

export function drawCrosshair(ctx: CanvasRenderingContext2D, chart: Chart) {
  const vp = chart.viewport;
  if (!chart.cursor.inChart) return;
  const w = vp.plot.width;
  const pricePaneH = vp.plot.height;
  const fullH = chart.fullPlotHeight;

  // snap x to hovered bar center; y free
  let x = chart.cursor.x;
  let snappedTime = NaN;
  if (chart.hoverIndex >= 0 && chart.data) {
    x = vp.xCenterOfIndex(chart.hoverIndex);
    snappedTime = chart.data.timeAt(chart.hoverIndex);
  }
  const y = chart.cursor.y;

  ctx.save();
  ctx.strokeStyle = Theme.crosshair;
  ctx.lineWidth = 1;
  ctx.setLineDash([4, 4]);

  // vertical spans the whole drawable area (price + indicator panes)
  ctx.beginPath();
  ctx.moveTo(Math.round(x) + 0.5, 0);
  ctx.lineTo(Math.round(x) + 0.5, fullH);
  // horizontal + price bubble only within the price pane
  if (chart.cursor.inPlot) {
    ctx.moveTo(0, Math.round(y) + 0.5);
    ctx.lineTo(w, Math.round(y) + 0.5);
  }
  ctx.stroke();
  ctx.setLineDash([]);

  if (chart.cursor.inPlot) {
    const price = vp.priceOfY(y);
    drawAxisTag(ctx, w, chart.priceAxisWidth, y, formatPrice(price, chart.priceDecimals), Theme.crosshairLabelBg, Theme.crosshairLabelText);
  }

  // time bubble (bottom gutter, below both panes)
  if (isFinite(snappedTime)) {
    const label = formatCrosshairTime(snappedTime, chart.tfSeconds);
    drawTimeBubble(ctx, x, fullH, chart.timeAxisHeight, w, label);
  }
  ctx.restore();
}

function drawTimeBubble(
  ctx: CanvasRenderingContext2D,
  x: number,
  y0: number,
  h: number,
  plotW: number,
  text: string
) {
  ctx.save();
  ctx.font = Fonts.axis;
  const padX = 8;
  const tw = ctx.measureText(text).width + padX * 2;
  let bx = x - tw / 2;
  bx = Math.max(0, Math.min(bx, plotW - tw));
  ctx.fillStyle = Theme.crosshairLabelBg;
  ctx.fillRect(bx, y0 + 1, tw, h - 2);
  ctx.fillStyle = Theme.crosshairLabelText;
  ctx.textBaseline = "middle";
  ctx.textAlign = "center";
  ctx.fillText(text, bx + tw / 2, y0 + h / 2 + 1);
  ctx.restore();
}
